export default "__VITE_ASSET__vw4tJQ7l__"